module.exports = __webpack_public_path__ + "img/preregister.b4b8b9db.jpg";